import myAxios from './myAxios';

export {
    getGeoContent,
    getGeoContents,
    addLicense,
    removePermit,
    getLicenses,
    getLicenseConsumption,
    addUpdateProduct
};

function getGeoContent(id) {
    return myAxios.get('/api/geocontent/' + id);
}

function getGeoContents() {
    return myAxios.get('/api/geocontent/');
}

function addLicense(email, prodid, exp, devnum) {
    return myAxios.post('/api/providers/addlicense', { prodid, email, exp, devnum })
}

function addUpdateProduct(prod) {
    var prd = JSON.stringify(prod);
    return myAxios.post('/api/providers/AddUpdateProduct', prd, {
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

function removePermit(userid, prodid) {
    return myAxios.get('/api/providers/removepermit', { params: { prodid, userid } })
}

function getLicenses(gcid) {
    return myAxios.get('/api/providers/getLicenses', { params: { gcid } })
}

function getLicenseConsumption(gcid) {
    return myAxios.get('/api/providers/getLicenseConsumption', { params: { gcid } })
}
